import {useDispatch, useSelector} from 'react-redux'
import {scrollToSection} from 'components/ScrollSpy'
import {OfferViewType} from 'context/offerViewContext'
import {useCloseTopOverlays} from 'hooks/useCloseTopOverlays/useCloseTopOverlays'
import {expandRoomsView} from 'modules/accommodation/slice'
import {getFilteredRoomsData} from 'modules/searchApi/selectors'

import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

import {COMPACT_ROOMS_AMOUNT} from '../../components/Accommodation/Rooms/constants'
import {useRoomsSectionScrollTarget} from '../useRoomsSectionScrollTarget'
import {getScrollTargetSpecificRoom} from './utils'

export const useHandleScrollToClickedOfferTarget = ({
  offerView
}: {
  offerView: OfferViewType
}) => {
  const dispatch = useDispatch()
  const {rooms} = useSelector(getFilteredRoomsData)
  const roomsSectionScrollTarget = useRoomsSectionScrollTarget()
  const closeTopOverlays = useCloseTopOverlays()

  const onOfferClick = (clickedOffer?: SearchOffer) => {
    const matchingRoomIndex = clickedOffer
      ? rooms.findIndex(room =>
          room.offers.some(offer => offer.id === clickedOffer.id)
        )
      : -1
    const matchingRoom = rooms[matchingRoomIndex]
    const shouldExpandRooms = matchingRoomIndex >= COMPACT_ROOMS_AMOUNT

    if (shouldExpandRooms) {
      dispatch(expandRoomsView())
    }

    const forceScrollToRoomsSection = [
      OfferViewType.AP_OVERLAY,
      OfferViewType.AP_FOOTER,
      OfferViewType.AP_DESKTOP
    ].includes(offerView)

    const scrollTarget =
      matchingRoom && !forceScrollToRoomsSection
        ? getScrollTargetSpecificRoom(matchingRoom.id)
        : roomsSectionScrollTarget

    closeTopOverlays()

    scrollToSection(scrollTarget, {deferred: true})
  }

  return {
    onOfferClick
  }
}
